import { Loader } from 'component/Loader/Loader'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { GenerationsEmptyScreen } from 'page/GenerationsScreen/GenerationsEmptyScreen'
import { InferenceCard, InferenceStub } from 'page/GenerationsScreen/InferenceCard'
import { InferenceList } from 'page/GenerationsScreen/InferenceList'
import { Page } from 'page/Page/Page'
import { useEffect } from 'react'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { times } from 'util/array'

export const GenerationsScreen = observer(() => {
  const { initialized, tab, inferences, listNew, listOld, listFav } =
    store.inferences
  const stub = store.inferences.busy
  const count = tab === 'fav' ? listFav.length : inferences.length
  const empty = !stub && !count
  const force = opt.tsum
  const size = opt.stand ? 16 : 12

  useEffect(() => {
    if (initialized && force) controller.openInference()
  }, [initialized])

  if (force)
    return (
      <Page center>
        <Loader />
      </Page>
    )

  if (empty) return <GenerationsEmptyScreen />

  if (stub)
    return (
      <Page long>
        <Vertical gap={16}>
          <Space>
            <Typo size={size} secondary>
              {i18n('YourOutfits')}
            </Typo>
          </Space>
          <InferenceList>
            {times(8).map((n) => (
              <InferenceStub key={n} />
            ))}
          </InferenceList>
        </Vertical>
      </Page>
    )

  if (tab === 'fav') {
    return (
      <Page long>
        <Vertical gap={16}>
          <InferenceList>
            {listFav.map((inference) => (
              <InferenceCard key={inference.key} inference={inference} />
            ))}
          </InferenceList>
        </Vertical>
      </Page>
    )
  }

  return (
    <Page long>
      <Vertical gap={16}>
        {!!listNew.length && (
          <Vertical gap={16}>
            <Space gap={4}>
              <Typo size={size} secondary>
                {i18n('NewOutfitsTitle')}
              </Typo>
              <Typo size={size}>{listNew.length}</Typo>
            </Space>
            <InferenceList>
              {listNew.map((inference) => (
                <InferenceCard key={inference.key} inference={inference} />
              ))}
            </InferenceList>
          </Vertical>
        )}
        {!!listOld.length && (
          <Vertical gap={16}>
            <Space gap={4}>
              <Typo size={size} secondary>
                {i18n('OldOutfitsTitle')}
              </Typo>
              <Typo size={size}>{listOld.length}</Typo>
            </Space>
            <InferenceList>
              {listOld.map((inference) => (
                <InferenceCard key={inference.key} inference={inference} />
              ))}
            </InferenceList>
          </Vertical>
        )}
      </Vertical>
    </Page>
  )
})
